<div class="card-title-block-non-sticky" *ngIf="isDocumentNotFound && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>document-card.data-not-found</span>
</div>
<div class="sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" *ngIf="!(isDocumentNotFound && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="invoiceData && invoiceDisplayed">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>commercial-documents.invoice-card</span>
					<span class="card-title-label card-title-name-label">{{invoiceData.name ? invoiceData.name : UNDERSCORE}}</span>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDocumentURL(invoiceData.id,invoiceData.name) | copoSafeUrl" target="_blank"
						type="application/pdf" (click)="scroller.saveState()" [title]="'quapp.action.view' | translate">
						<mat-icon color="accent" svgIcon="md:eye"></mat-icon>
					</a>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDownloadDocumentUrl(invoiceData.id,invoiceData.name) | copoSafeUrl" target="_blank"
						type="application/pdf" (click)="scroller.saveState(); trackDownload(invoiceData.id)" [title]="'sb.Download' | translate">
						<mat-icon color="accent" svgIcon="md:download"></mat-icon>
					</a>
				</div>
				<div class="copo-container footer-margin" copoAfterViewInit (afterviewinit)="scroller.restoreState()">
					<div class="grid-6">
						<div class="grid-column-one-full">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title class="card-content-title">
										<span translate>commercial-documents.payment-information</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.invoice-date</div>
										<div class="card-content-value">{{(invoiceData.date ? invoiceData.date : UNDERSCORE) | copoDate:'date'}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.invoice-type</div>
										<div class="card-content-value">{{invoiceData.subtypeDescription ? invoiceData.subtypeDescription : UNDERSCORE}} </div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.payment-due-date</div>
										<div class="card-content-value">{{(invoiceData.paymentDueDate ? invoiceData.paymentDueDate : UNDERSCORE) | copoDate:'date' }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.invoice-amount</div>
																			<div class="card-content-value">{{invoiceData.invoiceAmount | copoNumber:'amount'}}&nbsp;{{invoiceData.invoiceCurrency}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.invoice-amount-without-vat</div>
																			<div class="card-content-value">{{invoiceData.invoiceAmountWithoutVat | copoNumber:'amount'}}&nbsp;{{invoiceData.invoiceCurrency}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.invoice-tax-amount</div>
																			<div class="card-content-value">{{invoiceData.invoiceTaxAmount | copoNumber:'amount'}}&nbsp;{{invoiceData.invoiceCurrency}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.supplier-vat-number</div>
										<div class="card-content-value">{{invoiceData.supplierVatNumber ? invoiceData.supplierVatNumber : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.payer</div>
										<div class="card-content-value">{{invoiceData.payerName ? invoiceData.payerName : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.payer-vat-number</div>
										<div class="card-content-value">{{invoiceData.payerVatNumber ? invoiceData.payerVatNumber : UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>
					<div class="grid-column-one-full document-card-batch-order-details card-title-name-label" translate>commercial-documents.batches-details</div>
					<div class="grid-column-one-full document-card-orders-details-headers">
						<span translate>order.orders 
							<span>(&nbsp;{{orderNumbers.length}}&nbsp;)</span>
						</span>
						<div>
							<button type="button" translate class="tag-order-number tag-order-number-clickable batch-details-margin-left"
								[ngClass]="{'active-tag-order-number active-tag-order-number-clickable': allBatchesDisplayed }"
								(click)="allBatchesDisplayed = true; displayAllBatches()">datacenter.all
							</button>
						</div>
						<span *ngFor="let orderNumber of orderNumbers" class="batch-details-margin-left">
							<button type="button" class="tag-order-number tag-order-number-clickable"
								[ngClass]="{'active-tag-order-number active-tag-order-number-clickable': !allBatchesDisplayed && orderNumber.isSelected}"
								(click)="filterBatch(orderNumber)">
								{{orderNumber.key}}
							</button>
						</span>
					</div>
					<div
						*ngFor="let invoiceDetail of invoiceData.documentLines">
						<div *ngIf="invoiceDetail.isSelected" class="document-card-margin-bottom">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="batch-details-card-first-row invoice-card-margin">
											<div>
												<span class="card-sub-title" translate>shipment.filter.batch-number</span>
												<span class="card-sub-title">{{invoiceDetail.batchNumber ? invoiceDetail.batchNumber : UNDERSCORE}}</span>
												<span class="tag-order-number tag-order-number-not-active">{{ getOrderName(invoiceDetail) }}</span>
											</div>
											<div>
												<div class="card-content-value" translate>commercial-documents.invoice
													<span>&nbsp;({{invoiceDetail.invoiceCurrency ? invoiceDetail.invoiceCurrency : UNDERSCORE}})</span>
												</div>
												<div class="card-sub-title font-weight-applied">{{invoiceDetail.invoiceAmount ? invoiceDetail.invoiceAmount : UNDERSCORE}}</div>
											</div>
											<div>
												<span class="card-content-value" translate>commercial-documents.without-vat</span>&nbsp;<span>({{invoiceDetail.invoiceCurrency}})</span>
												<div class="card-sub-title font-weight-applied">{{invoiceDetail.invoiceAmountWithoutVat ? invoiceDetail.invoiceAmountWithoutVat : UNDERSCORE}}</div>
											</div>
											<div>
												<span class="card-content-value" translate>commercial-documents.vat</span>&nbsp;<span>({{PERCENTAGE}})</span>
												<div class="card-sub-title font-weight-applied">{{invoiceDetail.invoiceVatPercentage ? invoiceDetail.invoiceVatPercentage : UNDERSCORE}} </div>
											</div>
											<div>
												<span class="card-content-value" translate>commercial-documents.tax</span>&nbsp;<span>({{invoiceDetail.invoiceCurrency}})</span>
												<div class="card-sub-title font-weight-applied">{{invoiceDetail.invoiceTaxAmount ? invoiceDetail.invoiceTaxAmount : UNDERSCORE}}</div>
											</div>
										</div>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.plant-invoice-number</div>
										<div class="card-content-value">{{invoiceDetail.plantInvoiceNumber ? invoiceDetail.plantInvoiceNumber : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.invoiced-quantity</div>
										<div class="card-content-value">{{invoiceDetail.invoicedQuantity ? invoiceDetail.invoicedQuantity : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch.shipto </div>
										<div class="card-content-value">{{invoiceDetail.shiptoName ? invoiceDetail.shiptoName : UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate> filter.dispatchAdviceNumber</div>
										<div class="card-content-value">{{invoiceDetail.dispatchAdviceNumber ? invoiceDetail.dispatchAdviceNumber : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate> batch-card.mill</div>
										<div class="card-content-value">{{invoiceDetail.millDescription ? invoiceDetail.millDescription : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.end.user</div>
										<div class="card-content-value">{{invoiceDetail.enduserName ? invoiceDetail.enduserName : UNDERSCORE}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate> shipment.dispatch-advice-date</div>
										<div class="card-content-value">{{(invoiceDetail.dispatchAdviceDate ? invoiceDetail.dispatchAdviceDate : UNDERSCORE) | copoDate:'date'}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate> batch.card.customer </div>
										<div class="card-content-value">{{invoiceDetail.soldtoName ? invoiceDetail.soldtoName : UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																			</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>